/**
 * Stripe Payment Link helper.
 *
 * The credit-pack webhook attributes a purchase to an account via the
 * `client_reference_id` query param. A checkout started without it cannot be
 * credited to anyone, so callers must hide the Buy Credits link entirely when
 * there is no signed-in user (null return) rather than fall back to a bare URL.
 */
export function buildPaymentLinkUrl(userId: string | null | undefined): string | null {
  const PAYMENT_LINK_URL = process.env.REACT_APP_STRIPE_PAYMENT_LINK_URL ?? '';
  if (!userId) return null;
  // Env var missing (misconfigured build): send the user to the marketing
  // pricing page instead of a broken link. No query param — the URL ends in a
  // hash fragment, and the pricing page can't attribute a purchase anyway.
  if (!PAYMENT_LINK_URL) return 'https://getprivisy.com/#pricing';
  return `${PAYMENT_LINK_URL}?client_reference_id=${encodeURIComponent(userId)}`;
}

/**
 * Stash the current route so PaymentSuccessPage can send the buyer back to
 * where they were before starting checkout (see privisy_post_purchase_route
 * in PaymentSuccessPage.tsx). Call this from every Buy Credits entry point,
 * immediately before navigating to the payment link.
 */
export function stashPostPurchaseRoute(): void {
  sessionStorage.setItem('privisy_post_purchase_route', window.location.hash);
}
